// @ts-ignore
// import { store } from '../modules/store';

import {store} from "modules/store";

export type GrayConfigGroup = 'cd' | 'm';

export type GrayConfigModule =
  // 供应商（外包）- 工作台列表 - 选项
  | 'external.my_workbenches.filter_options'
  // 供应商（外包）- 工作台列表 - 列表
  | 'external.my_workbenches.list'
  // 供应商（外包）- 任务详情
  | 'external.demand_detail'
  // 供应商（外包）- 任务历史记录
  | 'external.demand_journal'
  // 供应商（外包）- 流程流转 - 待报价
  | 'external.demand_flow.pending_quote'
  // 供应商（外包）- 流程流转 - 制作中
  | 'external.demand_flow.making'
  // 供应商（外包）- 流程流转 - 变更报价
  | 'external.demand_flow.requote_price'
  // 供应商（外包）- 任务单附件 - 下载
  | 'external.demand_attaches_download'
  // 供应商（外包）- 任务单附件 - 上传
  | 'external.demand_attaches_upload'
  // 供应商（外包）- 公司信息附件 - 下载
  | 'external.supplier_attaches_download'
  // 供应商（外包）- 公司信息附件 - 上传
  | 'external.supplier_attaches_upload';

interface GrayConfig {
  groups: GrayConfigGroup[];
  modules: GrayConfigModule[];
}

export const GRAY_CONFIG_GROUP_MAP: Record<GrayConfigGroup, string> = {
  cd: 'CHANNEL_GROUP',
  m: 'MARKET_GROUP',
};

export const isDevOrTest = () => {
  const hostName = window.location.hostname;

  return (
    process.env.NODE_ENV !== 'production' ||
    hostName.includes('test') ||
    hostName.includes('mpcuat')
  );
};

export const hasGrayConfig = (
  group: GrayConfigGroup,
  modules: GrayConfigModule[]
) => {
  // @ts-ignore
  if (isDevOrTest() && !!window._disabled_gray) {
    return false;
  }

  const store = require('../modules/store').store;
  // @ts-ignore
  if (store) {
    // @ts-ignore
    const account = store.getState().account;
    const grayConfig = account.gray_config as GrayConfig;

    if (grayConfig) {
      return (
        grayConfig.groups.includes(group) &&
        modules.some((module) => grayConfig.modules.includes(module))
      );
    }
  }

  return false;
};

export const hasGrayConfigWithoutGroup = (modules: GrayConfigModule[]) => {
  // @ts-ignore
  if (isDevOrTest() && !!window._disabled_gray) {
    return false;
  }

  const store = require('../modules/store').store;
  // @ts-ignore
  if (store) {
    // @ts-ignore
    const account = store.getState().account;
    const grayConfig = account.gray_config as GrayConfig;

    if (grayConfig) {
      return modules.some((module) => grayConfig.modules.includes(module));
    }
  }

  return false;
};
